function initProductBundle(container = document) {
  const sections = container.querySelectorAll(".product-bundle-section");

  sections.forEach(section => {
    const bundleBtn = section.querySelector(".add-bundle-to-cart");
    const variants = section.querySelectorAll(".bundle-variant-id");

    if (!bundleBtn || !variants.length) return;

    function updateBundleTotal() {
      const bundleItems = section.querySelectorAll('.bundle-variant-id');
      let total = 0;

      bundleItems.forEach(item => {
        const price = parseInt(item.dataset.price) || 0;
        total += price;
      });

      const totalElement = section.querySelector('[data-bundle-total]');
      if (totalElement && typeof window.formatMoney === 'function') {
        const currencyCodeEnabled = window.themeVariables?.settings?.currencyCodeEnabled;
        const format = currencyCodeEnabled
          ? window.themeVariables?.settings?.moneyWithCurrencyFormat
          : window.themeVariables?.settings?.moneyFormat;
        totalElement.textContent = window.formatMoney(total, format);
      }
    }

    updateBundleTotal();

    bundleBtn.addEventListener("click", async () => {
      const items = [];

      variants.forEach(input => {
        if (input.value) {
          items.push({
            id: input.value,
            quantity: 1
          });
        }
      });

      if (!items.length) return;
      bundleBtn.classList.add("loading");

      try {
        const response = await fetch(window.Shopify?.routes?.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (response.ok) {
          const cart = await response.json();

          if (window.ajaxCart) {
            await window.ajaxCart.loadCart();
            window.ajaxCart.updateCartCount();

            if (window.ajaxCart.options.enableDrawer) {
              await window.ajaxCart.updateCartDrawerContent();
              window.ajaxCart.openDrawer();
            } else {
              window.location.href = window.Shopify.routes.root + 'cart';
            }
          } else {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            window.location.href = '/cart';
          }
        }
      } catch (err) {
        console.error('Bundle error:', err);
      } finally {
        bundleBtn.classList.remove("loading");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => initProductBundle());

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.product-bundle-section')) {
      initProductBundle(event.target);
    }
  });
}